export const FORGOT_PASSWORD_CREATE_REQUEST = 'FORGOT_PASSWORD_CREATE_REQUEST';
export const FORGOT_PASSWORD_CREATE = 'FORGOT_PASSWORD_CREATE';

export const FORGOT_PASSWORD_UPDATE_REQUEST = 'FORGOT_PASSWORD_UPDATE_REQUEST';
export const FORGOT_PASSWORD_UPDATE = 'FORGOT_PASSWORD_UPDATE';
